

export default {
  props: {
    removable: {
      type: Boolean,
      required: false
    },

    /**
     * @values icons
     */
    icon: {
      /** @type {AlturaIcons} */
      type: String,
      default: '',
      required: false
    },

    filled: {
      type: Boolean,
      default: false
    },

    /**
     * @values colors
     */
    color: {
      /** @type {AlturaColors} */
      type: String,
      default: 'primary-lighter',
      required: false
    },

    bold: {
      type: Boolean,
      required: false
    },

    compact: {
      type: Boolean,
      required: false
    },

    short: {
      type: Boolean,
      required: false
    }
  }
};
